import { forEach } from 'lodash'

export default {
  setSavedReport (state, report) {
    if (report.hasOwnProperty('id')) state.id = report.id
    if (report.hasOwnProperty('name')) state.name = report.name
    if (report.hasOwnProperty('needs_update')) state.needs_update = report.needs_update
    if (report.hasOwnProperty('user_id')) state.user_id = report.user_id
    if (report.hasOwnProperty('customer_id')) state.customer_id = report.customer_id
    if (report.hasOwnProperty('project_id')) state.project_id = report.project_id
    if (report.hasOwnProperty('maintenance_mode')) state.maintenance_mode = report.maintenance_mode
    if (report.hasOwnProperty('view_id')) state.view_id = report.view_id

    // Makes this field reactive
    forEach(report.filters, (columns, tableName) => {
      state.filters[tableName] = {}
      forEach(columns, (column, columnName) => {
        if (!state.filters[tableName][columnName]) {
          state.filters[tableName][columnName] = {}
        }
        state.filters[tableName][columnName].display_name = column.display_name
        state.filters[tableName][columnName].values = column?.values || []
        state.filters[tableName][columnName].isInControlArea = column.isInControlArea
      })
    })

    if (report.hasOwnProperty('time_frame_id')) state.time_frame_id = report.time_frame_id
    if (report.hasOwnProperty('time_frame_start')) state.time_frame_start = report.time_frame_start
    if (report.hasOwnProperty('time_frame_end')) state.time_frame_end = report.time_frame_end
    if (report.hasOwnProperty('created_at')) state.created_at = report.created_at
    if (report.hasOwnProperty('updated_at')) state.updated_at = report.updated_at
    if (report.hasOwnProperty('error')) state.error = report.error
    if (report.hasOwnProperty('authorFirstName')) state.authorFirstName = report.authorFirstName
    if (report.hasOwnProperty('authorLastName')) state.authorLastName = report.authorLastName
    if (report.hasOwnProperty('data')) state.data = report.data
    if (report.hasOwnProperty('type')) state.type = report.type
    if (report.hasOwnProperty('type_id')) state.type = report.type_id
  },
  clear (state) {
    state.id = null
    state.name = ''
    state.needs_update = false
    state.user_id = null
    state.customer_id = null
    state.project_id = null
    state.maintenance_mode = false
    state.view_id = null
    state.filters = {}
    state.time_frame_id = null
    state.time_frame_start = null
    state.time_frame_end = null
    state.created_at = null
    state.updated_at = null
    state.error = ''
    state.authorFirstName = ''
    state.authorLastName = ''
    state.data = {}
    state.type = ''
    state.type_id = null
  }
}
